<div class="w-full px-6 py-8 space-y-10">
    <form [formGroup]="form" (ngSubmit)="onSubmit1()" class="space-y-10">

        <!-- Section: Lead Info -->
        <div class="bg-white rounded-2xl shadow-lg p-6 space-y-6">
            <div class="flex items-center gap-2 border-b pb-2">
                <div class="w-[4px] h-6 bg-primary"></div>
                <h2 class="text-xl font-semibold text-gray-800">Lead Information</h2>
            </div>

            <div class="user-group grid grid-cols-12  pt-4 px-6 gap-8">
                <ng-container *ngFor="let field of leadFields">
                    <div class="col-span-6">
                        <mat-label>{{ field.label }} <span *ngIf="field.required">*</span></mat-label>

                        <mat-form-field appearance="outline" class="w-full bg-white rounded-md">

                            <ng-container [ngSwitch]="field.type">
                                <mat-select *ngSwitchCase="'select'" [formControlName]="field.name">
                                    <mat-option value="">Select</mat-option>
                                    <mat-option value="Mr">Mr</mat-option>
                                    <mat-option value="Ms">Ms</mat-option>
                                </mat-select>

                                <textarea *ngSwitchCase="'textarea'" matInput rows="2"
                                    [formControlName]="field.name"></textarea>

                                <input *ngSwitchDefault matInput type="text" [formControlName]="field.name" />
                            </ng-container>

                            <mat-error *ngIf="submitted && f[field.name].errors?.['required']">
                                {{ field.label }} is required
                            </mat-error>
                        </mat-form-field>
                    </div>

                </ng-container>
            </div>
        </div>

        <!-- Section: Contact Details -->
        <div class="bg-white rounded-2xl shadow-lg p-6 space-y-6">
            <div class="flex items-center gap-2 border-b pb-2">
                <div class="w-[4px] h-6 bg-primary"></div>
                <h2 class="text-xl font-semibold text-gray-800">Contact Details</h2>
            </div>

            <div class="user-group grid grid-cols-12  pt-4 px-6 gap-8">
                <ng-container *ngFor="let field of contactFields">
                    <div class="col-span-6">
                        <mat-label>{{ field.label }}</mat-label>

                        <mat-form-field appearance="outline" class="w-full bg-white rounded-md">
                            <input matInput type="text" [formControlName]="field.name" />
                        </mat-form-field>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Submit Button -->
        <div class="flex justify-end">
            <button mat-raised-button color="primary" type="submit" class="rounded-xl px-6 py-2">
                Register
            </button>
        </div>
    </form>
</div>




<!-- <div class="w-full pr-10 gap-6 flex flex-col">
    <div class="flex w-full justify-between"></div>
    <form [formGroup]="form" (ngSubmit)="onSubmit1()" class="login-container w-full">
        <div class="flex h-full gap-10 w-full flex-col xl:flex-row">
            <div class="w-full flex flex-col gap-6">
                <div class="w-full bg-white rounded-xl h-full">
                    <div class="flex p-4 space-x-2 items-center">
                        <div class="h-8 w-[4px] bg-primary"></div>
                        <span> Lead</span>
                    </div>

                    <div class="p-4 flex flex-col gap-4">
                        <div class="flex flex-col gap-2">
                            
                            <span class="text-sm">Salutation *</span>

                            <select class="w-full p-2 outline-none border rounded-md" formControlName="salutation"
                                name="salutation">
                                <option value="">Select</option>
                                <option value="Mr">Mr</option>
                                <option value="Ms">Ms</option>
                            </select>
                            <div *ngIf="submitted && f['salutation'].errors" class="error">
                                <div *ngIf="f['salutation'].errors['salutation']">
                                    Status is required
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col gap-2">
                            <span class="text-sm">First Name *</span>
                            <input type="text" formControlName="firstName"
                                class="w-full border p-2 rounded-md outline-none" [ngClass]="{
                    'is-invalid': submitted && f['firstName'].errors
                  }" />
                            <div *ngIf="submitted && f['firstName'].errors" class="error">
                                <div *ngIf="f['firstName'].errors['required']">
                                    First Name is required
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col gap-2">
                            <span class="text-sm">Last Name *</span>
                            <input type="text" formControlName="lastName"
                                class="w-full border p-2 rounded-md outline-none" [ngClass]="{
                    'is-invalid': submitted && f['lastName'].errors
                  }" />
                            <div *ngIf="submitted && f['lastName'].errors" class="error">
                                <div *ngIf="f['lastName'].errors['required']">
                                    Last Name is required
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col gap-2">
                            <span class="text-sm">Job Title </span>
                            <input type="text" formControlName="jobTitle"
                                class="w-full border p-2 rounded-md outline-none" />

                        </div>
                        <div class="flex flex-col gap-2">
                            <span class="text-sm">Department </span>
                            <input type="text" formControlName="department"
                                class="w-full border p-2 rounded-md outline-none" />

                        </div>
                        <div class="flex flex-col gap-2">
                            <span class="text-sm">AccountName </span>
                            <input type="text" formControlName="accountName"
                                class="w-full border p-2 rounded-md outline-none" />

                        </div>
                        <div class="flex flex-col gap-2">
                            <span class="text-sm">Primary Address Street </span>
                            <input type="text" formControlName="primaryAddressStreet"
                                class="w-full border p-2 rounded-md outline-none" />

                        </div>
                        <div class="flex flex-col gap-2">
                            <span class="text-sm">Primary Address Postal code </span>
                            <input type="text" formControlName="primaryAddressPostalcode"
                                class="w-full border p-2 rounded-md outline-none" />

                        </div>
                        <div class="flex flex-col gap-2">
                            <span class="text-sm">Primary Address  City </span>
                            <input type="text" formControlName="primaryAddressCity"
                                class="w-full border p-2 rounded-md outline-none" />

                        </div>
                        <div class="flex flex-col gap-2">
                            <span class="text-sm">Primary Address  State </span>
                            <input type="text" formControlName="primaryAddressState"
                                class="w-full border p-2 rounded-md outline-none" />

                        </div>
                        <div class="flex flex-col gap-2">
                            <span class="text-sm">Primary Address Country  </span>
                            <input type="text" formControlName="primaryAddressCountry"
                                class="w-full border p-2 rounded-md outline-none" />

                        </div>
                        <div class="flex flex-col gap-2">
                            <span class="text-sm">Email *</span>
                            <input type="text" formControlName="email"
                                class="w-full border p-2 rounded-md outline-none" [ngClass]="{
                    'is-invalid': submitted && f['email'].errors
                  }" />
                            <div *ngIf="submitted && f['email'].errors" class="error">
                                <div *ngIf="f['email'].errors['required']">
                                    Email is required
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-col gap-2">
                            <span class="text-sm">Description </span>
                            <textarea type="text" formControlName="description"
                                class="w-full border p-2 rounded-md outline-none" ></textarea>
                        </div>
    



                    </div>
                </div>
            </div>
            <div class="w-full bg-white p-4 rounded-xl h-full">
                <div class="p-8 flex flex-col gap-4">
                    <div class="flex flex-col gap-2">
                        <span class="text-sm">Office Phone</span>
                        <input type="text" formControlName="officePhone"
                            class="w-full border p-2 rounded-md outline-none" />

                    </div>
                    <div class="flex flex-col gap-2">
                        <span class="text-sm">Mobile</span>
                        <input type="text" formControlName="mobile"
                            class="w-full border p-2 rounded-md outline-none" />

                    </div>
                    <div class="flex flex-col gap-2">
                        <span class="text-sm">Fax</span>
                        <input type="text" formControlName="fax"
                            class="w-full border p-2 rounded-md outline-none" />

                    </div>
                    <div class="flex flex-col gap-2">
                        <span class="text-sm">Website</span>
                        <input type="text" formControlName="website"
                            class="w-full border p-2 rounded-md outline-none" />

                    </div>
                    <div class="flex flex-col gap-2">
                        <span class="text-sm">Alt Address Street</span>
                        <input type="text" formControlName="altAddressStreet"
                            class="w-full border p-2 rounded-md outline-none" />

                    </div>
                    <div class="flex flex-col gap-2">
                        <span class="text-sm">Alt Address Postal code </span>
                        <input type="text" formControlName="altAddressPostalcode"
                            class="w-full border p-2 rounded-md outline-none" />

                    </div>
                    <div class="flex flex-col gap-2">
                        <span class="text-sm">Alt Address  City *</span>
                        <input type="text" formControlName="altAddressCity"
                            class="w-full border p-2 rounded-md outline-none" />

                    </div>
                    <div class="flex flex-col gap-2">
                        <span class="text-sm">Alt Address  State </span>
                        <input type="text" formControlName="altAddressState"
                            class="w-full border p-2 rounded-md outline-none" />

                    </div>
                    <div class="flex flex-col gap-2">
                        <span class="text-sm">Alt Address Country  </span>
                        <input type="text" formControlName="altAddressCountry"
                            class="w-full border p-2 rounded-md outline-none" />

                    </div>
                  
                   

                </div>
            </div>
        </div>
    </form>

    <div class="w-full flex items-center justify-end">
        <button (click)="onSubmit1()" class="rounded-xl p-3 w-60 text-white bg-primary">
            Register
        </button>
    </div>
</div> -->